import Lookup from 'src/componentes/select2';

const TipoDocumentoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/TipoDocumentoLookup"
    clearable
    {...rest}
  />
);

export default TipoDocumentoLookup;
